module.exports = __webpack_public_path__ + "static/media/with-box.65bff6c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/with-box.png
// module id = 373
// module chunks = 0